// One-shot hand-off of resolved session ids from the sessions list's "Replay
// matching sessions" action to the bulk-replay launch form. Session ids can run
// into the thousands, so they go through sessionStorage rather than the URL.
const KEY = 'bulk-replay-session-ids';

export function stashReplaySessionIds(sessionIds: string[]): void {
  sessionStorage.setItem(KEY, JSON.stringify(sessionIds));
}

/** Reads and clears the stashed ids (consume-once). Returns null if none/invalid. */
export function takeReplaySessionIds(): string[] | null {
  const raw = sessionStorage.getItem(KEY);
  if (raw === null) return null;
  sessionStorage.removeItem(KEY);
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.every((v) => typeof v === 'string') ? parsed : null;
  } catch {
    return null;
  }
}
